import type { InativarAtivarEscopoPadraoProps } from "./types-inativar-ativar-escopo-padrao";
import { useInativarAtivarEscopoPadrao } from "./use-inativar-ativar-escopo-padrao";
import { InativarAtivarEscopoPadraoView } from "./view-inativar-ativar-escopo-padrao";

export function InativarAtivarEscopoPadrao(props: InativarAtivarEscopoPadraoProps) {
  const vm = useInativarAtivarEscopoPadrao(props);

  return <InativarAtivarEscopoPadraoView {...vm} />;
}

export type * from "./types-inativar-ativar-escopo-padrao";
